import { fetchData } from '@hooks/use-api-requests.hook'
import type { APIRequest ,APIParams} from '@hooks/use-api-requests.hook'

export function generateQueryParams(params: Record<string, string>) {
	return Object.keys(params).length > 0
		? `?${new URLSearchParams(params).toString()}`
		: ''
}

export function generateEndpointUrl(
	endpoint: string,
	requests: APIRequest,
	params?: Record<string, string>
) {
	return `${endpoint}/api/${requests}${generateQueryParams(params || {})}`
}

export async function fetchValidation<T>(
	args: APIParams<T>
): Promise<T | undefined> {
	const { request, method = 'GET', queryParams, file = false, body } = args

	const API_URL = import.meta.env.VITE_API_URL

	const endpoint = generateEndpointUrl(API_URL, request, queryParams)
	const abortController = new AbortController()

	const data = fetchData<T>(
		method,
		endpoint,
		file,
		abortController.signal,
		body ?? {}
	)

	return data
}

export function calculateCAP(cap: string | null) {
	if (!cap) {
		return ''
	} else if (cap === '') {
		return cap
	}

	return cap.padStart(5, '0')
}
